import React from "react";
import { withRouter } from "react-router-dom";

import { Box, Icon, useBackgroundColor } from "@seneca/senekit";

import SideDrawer, {
  Props as SideDrawerProps
} from "features/common/components/SideDrawer";
import Logo from "features/common/logos/Logo";

type Props = SideDrawerProps & {
  children: {
    options: (arg0: () => void, arg1: () => void) => React.ReactNode;
  };
};

function NavbarSideDrawer({ children: { options } }: Props) {
  const backgroundColor = useBackgroundColor();

  return (
    <SideDrawer
      openFromRight
      renderButton={(onClick: any) => (
        <Box onClick={onClick} height="32px" width="32px" marginRight="large">
          <Icon
            iconName="hamburgerMenu"
            accessibilityLabel="Menu"
            size="fill"
            tone="neutral"
          />
        </Box>
      )}
      renderContents={(closeDrawer: any, openDrawer: any) => (
        <>
          <Box backgroundColor={backgroundColor} padding="xlarge">
            <Logo height="24px" width="auto" />
          </Box>
          <Box padding="xlarge">{options(closeDrawer, openDrawer)}</Box>
        </>
      )}
    />
  );
}

// @ts-ignore
export default withRouter(NavbarSideDrawer);
